import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { PpbSharedModule } from '../ppb-shared.module';
import { PseiNgCustomModule } from '../psei-ng-custom.module';
import { IalConfirmationComponent } from './account/ial-confirmation/ial-confirmation.component';

@NgModule({
  imports: [
    PseiNgCustomModule,
    CommonModule,
    FlexModule,
    ReactiveFormsModule,
    PpbSharedModule
  ],
  declarations: [IalConfirmationComponent],
  exports: [IalConfirmationComponent]
})
export class PpbLibAppModule {
}
